import { captureException } from '@sentry/node';
import { Response } from 'express';

import { isAxiosError } from '@r1-frontend/do-request/guards/isAxiosError';

import { TAppThunkDispatch } from '~/src/store';
import { getClientAll } from '~/src/store/actions/auth/getClientAll';
import { logout } from '~/src/store/actions/auth/logout';

/** @deprecated use frontend/apps/b2c-domru/src/store/actions/auth/getInfoAll.ts **/
export const loginByAccessToken = (agreementNumber?: string, response?: Response): (dispatch: TAppThunkDispatch) => Promise<{
    isValidAccessToken: boolean,
}> => {
    return async(dispatch: TAppThunkDispatch) => {
        try {
            await dispatch(getClientAll(response, agreementNumber));

            return { isValidAccessToken: true };
        } catch (e) {
            if (isAxiosError(e) && e.response?.status === 401) {
                dispatch(logout(response));
                return { isValidAccessToken: false };
            }

            captureException(e);
            return { isValidAccessToken: false };
        }
    };
};
